<template>
  <div class="flex flex-wrap justify-center">
    <div class="max-w-xl min-w-full sm:min-w-30 m-2">
      <div class="bg-white rounded-lg shadow-card p-8 sm:p-12">
        <Spinner class="mx-auto" />
      </div>
    </div>
   
  </div>
</template>

<script>
  import Spinner from "@/components/common/Spinner"

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
       
      }
    },
  }
</script>